var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',{class:_vm.$vuetify.theme.dark ? '' : _vm.getBackgroundColor},[_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }